/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { Button, Form } from '@finbeat/react-toolkit';
import { changeProps, getProps } from 'axios/propApi';
import { BOProps } from 'base-components/BOProps/BOProps';
import useApi from 'hooks/useApi';
import useAuth from 'hooks/useAuth';
import { Prop, PropExtended } from 'models/api/prop';
import { PropModels } from 'models/api/tariffGroup';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { Container, Spinner } from 'reactstrap';
import './DeclinedShowcase.scss';

const LeftColumn = () => {
    const api = useApi();
    const { hasRole } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [props, setProps] = useState<Prop[]>([]);

    const { isFetching } = useQuery(
        'DeclinedShowcaseProps',
        () => getProps(api, 'DeclinedShowcase', '0'),
        {
            onSuccess: (data) => {
                setProps(
                    data.map<PropExtended>((prop) => ({
                        ...prop,
                        ...(prop.code === 'AutoRedirectTime' ? { max: 1000, min: 1 } : {}),
                    }))
                );
            },
            enabled: props.length === 0,
        }
    );

    const rootClassName = 'declined-showcase';
    const className = `${rootClassName}-settings`;
    const saveChanges = async ({ props }: PropModels) => {
        setIsLoading(true);
        await changeProps(api, props, '0');
        setProps(props);
        setIsLoading(false);
    };

    const defaultValues = {
        props,
    };

    return !(isLoading || isFetching) ? (
        <Form<PropModels>
            onSubmit={saveChanges}
            defaultValues={defaultValues}
            className="form-in-modal"
            testId="left-column"
        >
            <BOProps<PropModels> name="props" />
            {hasRole('propsUpdate') && (
                <Button className={`${className}__loader-button`} color="primary" type="submit">
                    <Trans i18nKey="BackOfficeSave" />
                </Button>
            )}
        </Form>
    ) : (
        <Container fluid className={`${className}__loader`}>
            <Spinner />
        </Container>
    );
};

export default LeftColumn;
